// extracted by mini-css-extract-plugin
export default {"dark":"CreateAccountUser_dark__uCLnp","App":"CreateAccountUser_App__bMEc7","formContainer":"CreateAccountUser_formContainer__2f7oa"};